import { isDefined } from '../util/Common';

export const If = (props) => {
    return isDefined(props.children) && props.test ? (
        props.children
    ) : (
        null
    )
}


// WEBPACK FOOTER //
// ./src/components/ConditionalRendering.js